const BADGES = [
  {
    icon: "ri-shield-check-line",
    title: "Licensed & Insured",
    description:
      "Fully licensed business operating in full compliance. Your property and our team are always protected.",
    detail: "Doc No. L21000385737",
    since: "Active since 2021",
    accent: "text-teal-600",
    bg: "bg-teal-50",
    border: "border-teal-100",
    iconBg: "bg-teal-600",
  },
  {
    icon: "ri-leaf-line",
    title: "Eco-Certified",
    description:
      "We use only plant-based, non-toxic, biodegradable products — safe for your family, pets, and our planet.",
    detail: "100% Green Products",
    since: "Non-toxic formulas",
    accent: "text-emerald-600",
    bg: "bg-emerald-50",
    border: "border-emerald-100",
    iconBg: "bg-emerald-600",
  },
  {
    icon: "ri-medal-line",
    title: "Satisfaction Guarantee",
    description:
      "Not happy? We'll come back and make it right — free of charge. We don't stop until you're 100% satisfied.",
    detail: "Free Re-clean Policy",
    since: "No questions asked",
    accent: "text-amber-600",
    bg: "bg-amber-50",
    border: "border-amber-100",
    iconBg: "bg-amber-500",
  },
  {
    icon: "ri-team-line",
    title: "Vetted Professionals",
    description:
      "Every cleaner passes a thorough background check and hands-on training before stepping into your home.",
    detail: "Background Checked",
    since: "Trained & certified",
    accent: "text-rose-600",
    bg: "bg-rose-50",
    border: "border-rose-100",
    iconBg: "bg-rose-500",
  },
];

const STATS = [
  { value: "4+", label: "Years in Business" },
  { value: "1,200+", label: "Happy Clients" },
  { value: "98%", label: "Satisfaction Rate" },
  { value: "0", label: "Damage Claims" },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-24" style={{ background: "#f9fafb" }}>
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-semibold uppercase tracking-widest text-teal-600 mb-3 block">
            Our Commitment
          </span>
          <h2
            className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-5"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Why Clients Choose{" "}
            <span className="text-teal-600">ZoroBabel</span>
          </h2>
          <p className="text-gray-500 text-sm leading-relaxed max-w-lg mx-auto">
            We're not just a cleaning company — we're a trusted partner backed by credentials, certified practices, and a genuine commitment to your satisfaction.
          </p>
        </div>

        {/* Badges grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {BADGES.map((b) => (
            <div
              key={b.title}
              className={`${b.bg} border ${b.border} rounded-2xl p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${b.iconBg}`}>
                <i className={`${b.icon} text-white text-xl`} />
              </div>
              <div>
                <h3
                  className="text-base font-bold text-gray-900 mb-2"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {b.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-4">
                  {b.description}
                </p>
                <div className="flex flex-col gap-1">
                  <span className={`text-xs font-semibold ${b.accent} flex items-center gap-1.5`}>
                    <i className="ri-check-double-line text-sm" />
                    {b.detail}
                  </span>
                  <span className="text-xs text-gray-400 flex items-center gap-1.5">
                    <i className="ri-time-line text-sm" />
                    {b.since}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="bg-teal-600 rounded-2xl px-8 py-8 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className={`text-center ${
                i < STATS.length - 1
                  ? "lg:border-r border-teal-500"
                  : ""
              }`}
            >
              <div
                className="text-3xl font-extrabold text-white mb-1"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {s.value}
              </div>
              <div className="text-xs font-medium text-teal-100 uppercase tracking-wide">
                {s.label}
              </div>
            </div>
          ))}
        </div>

        {/* License badge */}
        <div className="mt-6 flex justify-center">
          <div className="inline-flex items-center gap-3 bg-white border border-gray-100 rounded-full px-5 py-2.5">
            <div className="w-7 h-7 flex items-center justify-center bg-teal-600 rounded-full">
              <i className="ri-government-line text-white text-sm" />
            </div>
            <span className="text-xs text-gray-500">
              Miami, FL Licensed Business &nbsp;·&nbsp;
              <strong className="text-gray-700">Doc No. L21000385737</strong>
              &nbsp;·&nbsp; Active since 2021 &nbsp;·&nbsp;
              <span className="text-gray-600">Manager: Luz C. Diaz Tafur</span>
            </span>
          </div>
        </div>

      </div>
    </section>
  );
}
